export const getBoxPositions = (grefs,ref, scrollTop) => {
  const returnx = Object.keys(grefs[ref].current).reduce((a, b) => {
    if (grefs[ref].current[b].current) {
      const box = grefs[ref].current[b].current.getBoundingClientRect();
      return {
        ...a,
        [b]: {
          left: box.left,
          top: box.top + scrollTop,
          width: box.width,
        },
      };
    } else {
      return {
        ...a,
        [b]: {
          left: null,
          top: null,
          width: null,
        },
      };
    }
  }, {});

  return returnx;
};
